import { createAction } from 'redux-actions';
import {
	POST_OTP_SEND_CODE_CALL, POST_OTP_SEND_CODE_DONE, POST_OTP_SEND_CODE_FAIL,
	POST_OTP_VERIFY_CALL, POST_OTP_VERIFY_DONE, POST_OTP_VERIFY_FAIL,
	RESET_OTP_STATE,
} from '@src/store/types/otp';

export const postOtpSendCodeCall = createAction(POST_OTP_SEND_CODE_CALL);
export const postOtpSendCodeDone = createAction(POST_OTP_SEND_CODE_DONE);
export const postOtpSendCodeFail = createAction(POST_OTP_SEND_CODE_FAIL);

export const postOtpVerifyCall = createAction(POST_OTP_VERIFY_CALL);
export const postOtpVerifyDone = createAction(POST_OTP_VERIFY_DONE);
export const postOtpVerifyFail = createAction(POST_OTP_VERIFY_FAIL);

export const resetOtpState = createAction(RESET_OTP_STATE);
